<script>
    import {
        getFormatDateAndTime,
        getText,
        goToURL,
    } from "../../../Utils/utilFunctions.svelte";

    export let eclipseLogData = {};

    let isShowInfo = true;

    // HELPER FUNCTIONS
    const _toggleShowHideDetails = () => {
        isShowInfo = !isShowInfo;
    };

    const _getActionName = (actionType) => {
        switch (actionType) {
            case 0:
                return "POST";
            case 1:
                return "GET";
            case 3:
                return "PUT";
            case 4:
                return "DELETE";
            default:
                return "";
        }
    };

    const _redirectToAccount = () => {
        goToURL(`/Account/view/${eclipseLogData.accountId}`);
    };

    const _redirectToEncounter = () => {
        goToURL(`/PatientEncounter/view/${eclipseLogData.encounterId}`);
    };
</script>

<div
    class={`transition flex flex-col w-full lg:flex-row ${
        isShowInfo ? "" : "max-h-[50px]"
    }`}
>
    <div
        class="flex-1 h-full card bg-white rounded-box border"
    >
        <div
            class="flex justify-between pr-4 text-white cursor-pointer bg-gradient-to-b from-bg-primary to-bg-secondary"
            on:click|preventDefault={_toggleShowHideDetails}
        >
            <p class="font-bold px-2 py-4">Basic Information</p>
        </div>

        <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
            <div class="flex flex-col flex-1 gap-y-4 h-full">
                <div class="flex flex-row gap-x-2">
                    <p class="title">Action Time:</p>
                    <p class="content">
                        {getFormatDateAndTime(eclipseLogData?.createdDate)}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Action:</p>
                    <p class="content">
                        {_getActionName(eclipseLogData?.actionType)}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">URL:</p>
                    <p class="content break-all">
                        {getText(eclipseLogData?.apiUrl)}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Doctor Name:</p>
                    {#if eclipseLogData?.accountName}
                        <p
                            class="content break-all cursor-pointer underline hover:font-bold"
                            on:click|preventDefault={_redirectToAccount}
                        >
                            {getText(eclipseLogData?.accountName)}
                        </p>
                    {:else}
                        <p class="content cursor-default">Unknown Doctor</p>
                    {/if}
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Encounter ID:</p>
                    {#if eclipseLogData?.encounterId}
                        <p
                            class="content break-all cursor-pointer underline hover:font-bold"
                            on:click|preventDefault={_redirectToEncounter}
                        >
                            {getText(eclipseLogData?.encounterId)}
                        </p>
                    {:else}
                        <p class="content cursor-default">
                            Unknown Patient Encounter
                        </p>
                    {/if}
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Transaction ID:</p>
                    <p class="content break-all">
                        {getText(eclipseLogData?.transactionId)}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Description:</p>
                    {#if eclipseLogData?.description}
                        <p class="content break-all">
                            {getText(eclipseLogData?.description)}
                        </p>
                    {:else}
                        <p class="content">No description</p>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .title {
        width: 150px;
    }

    .content {
        width: calc(100% - 150px);
    }

    .transition {
        transition: 0.5s linear;
    }
</style>
